export default "__VITE_ASSET__3uJPXRI8__"